import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Fragment } from 'react';

export default function TableActionMenu({ menuItem, data, keyRandom }) {
  return <>
    {
      menuItem.map((option, index) => (
        <Fragment key={`${keyRandom || 'table-action-menu'}-${index}`}>
          <FontAwesomeIcon className="edit-icon" onClick={() =>  option.actionFnc(data)} icon={option.action === 'edit' ? faEdit : faTrash} />
        </Fragment>
      ))
    }
  </>
}